export default {"src":"/_next/static/media/faq.e6ceec6c.svg","height":116,"width":336,"blurWidth":0,"blurHeight":0};